import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { tableStylesSAG, tableStylesSHS } from './table.styles';
import { style } from '../utils/style.utils';

@Directive({
  selector: 'table[sag-ui-table]',
})
export class TableDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      tableStylesSAG,
      tableStylesSHS
    );
    style(this.elementRef, inputStyles());
  }
}
